/** Game art in the DOM overlay: a cropped atlas frame (or fallback canvas) as a CSS background. */
import type { JSX } from 'preact';

type Source = (id: string, box: number) => Record<string, string>;
let source: Source | null = null;

export function setSpriteSource(fn: Source): void {
  source = fn;
}

export function Sprite({ id, size, class: cls }: { id: string; size: number; class?: string }): JSX.Element | null {
  if (!source) return null;
  return (
    <span class={`sprite-box ${cls ?? ''}`} style={{ width: `${size}px`, height: `${size}px` }} aria-hidden="true">
      <i style={source(id, size)} />
    </span>
  );
}
